import React from 'react';
import { RosaPatientRecordsQueryProvider } from './RosaPatientRecordsQueryProvider';

export const RosaPatientRecordsProviders = ({ children }: any) => {
	return <RosaPatientRecordsQueryProvider>{children}</RosaPatientRecordsQueryProvider>;
};
